<template>
  <div class="pump-retrieve-form">
    <div class="text-xl my-2 text-primary-color">Reparatie aanvragen</div>
    <div class="text-base my-2 text-primary-color">{{ data.pumpDesc }} {{ data.serialNo }}</div>
    <div class="grid grid-rows gap-2">
      <div class="">
        <p class="text-black font-bold m-0">Ophaaldatum*</p>
        <v-input-date-picker
          class="py-2 ga-track-btn ga-track-pickup_date"
          id="pumpMaintenanceDate"
          ref="date"
          type="date"
          name="pumpMaintenanceDate"
          autofocus
          disable-dates
          disable-past-dates
          :overwrite-value="maintenanceDate"
          :disable-dates-for-pump-pickup="disableDatesForPickUp"
          :smallest-date="smallestDate"
          :dates-by-postalcode="differentPickupDates"
          @update-validation="updatePumpMaintenanceDate"
        />
      </div>
      <div class="">
        <v-input-group-simple-2
          :id="formConfig.ErrorCode.ref"
          v-model="formConfig.ErrorCode.model"
          type="text"
          :rules="{
            required: false
          }"
          :label="formConfig.ErrorCode.label"
        />
      </div>
      <div class="">
        <textarea
          id="remarks"
          class="p-2 w-full rounded border border-primary-default my-4"
          placeholder="Opmerking (optioneel)"
          @input="setRemarks($event.target.value)"
        />
      </div>
      <div class="flex flex-row justify-end gap-4">
        <a
          class="text-pdsPrimaryColor font-bold mt-2 cursor-pointer text-xs md:text-base"
          @click.prevent="cancelRetrievePump()"
        >
          Annuleren
        </a>
        <button
          @click.once="saveRetrievePump()"
          class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full text-nowrap"
        >
          Bevestigen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useForm } from 'vee-validate';
import { activePpwRecId$ } from '@/services';
import { ref } from 'vue';
import VInputDatePicker from '@/components/shared/form/simple/InputDatePicker';
import moment from 'moment';
import store from '@/store';

export default {
  name: 'VPumpretrieveform',
  components: { VInputDatePicker },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    const disableDatesForPickUp = ref('');
    const smallestDate = ref('');
    const differentPickupDates = ref('');
    const activePpwRecId = ref(null);
    const maintenanceDate = ref('');

    axios.get('Equipment/GetPostCode').then((response) => {
      if (response) {
        fetchDisableDatesForPostalCode(response.data);
      }
    });

    const updatePumpMaintenanceDate = (value) => {
      maintenanceDate.value = value;
    };

    const fetchDisableDatesForPostalCode = async (postalCode) => {
      if (postalCode && postalCode.length > 3) {
        let code = postalCode.split(' ')[0];
        if (code.length === 4) {
          let response = await getDisabledDatesForPumpsPickUp(code);
          if (response && response.data) {
            let parsedunSelectedableDates = response.data.unSelectableDates.map(
              (dateElement) => new String(moment(dateElement, 'D-M-YYYY').format('MM-DD-YYYY'))
            );
            disableDatesForPickUp.value = parsedunSelectedableDates;
            const parsedSmallestDate = moment(response.data.smallestDate).format('MM-DD-YYYY');
            smallestDate.value = parsedSmallestDate;
            maintenanceDate.value = parsedSmallestDate;
            differentPickupDates.value = true;
          }
        }
      }
    };

    const getDisabledDatesForPumpsPickUp = (value) =>
      store.dispatch('pumpOverview/getUnSelectableDatesForPostalCode', value);

    activePpwRecId$.subscribe((value) => {
      activePpwRecId.value = value;
    });

    return {
      activePpwRecId,
      disableDatesForPickUp,
      smallestDate,
      differentPickupDates,
      maintenanceDate,
      updatePumpMaintenanceDate,
      fetchDisableDatesForPostalCode
    };
  },
  data() {
    const { validate } = useForm();

    return {
      validate,
      formConfig: {},
      isRepair: false,
      pumpData: {}
    };
  },
  created() {
    this.setFormConfig();
    this.pumpData = {
      ErrorCode: '',
      Comment: '',
      SerialNo: this.data.serialNo,
      PumpID: this.data.equipmentID,
      PpwRecId: this.activePpwRecId,
      PickUpDate: ''
    };
  },
  methods: {
    moment(...args) {
      return moment(...args);
    },
    cancelRetrievePump() {
      this.$emit('closeModal');
    },
    saveRetrievePump() {
      this.validateAllFields();
      this.$emit('closeModal');
    },
    setFormConfig() {
      this.formConfig = {
        ErrorCode: {
          ref: 'ErrorCode',
          label: 'Foutcode op pomp',
          model: this.pumpData.ErrorCode,
          rule: {
            required: false
          },
          attached: true,
          error: false,
          errorMessage: 'Vul de foutcode in die op de pomp is weergegeven.'
        }
      };
    },
    async validateAllFields(elements) {
      const result = await this.validate();
      this.pumpData['PickUpDate'] = moment(this.maintenanceDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
      if (result.valid) {
        for (let key in this.pumpData) {
          if (this.formConfig.hasOwnProperty(key) && this.formConfig[key].model !== undefined) {
            this.pumpData[key] = this.formConfig[key].model;
          }
        }
        axios.post('Equipment/EmailToRetrievePump', this.pumpData).then((response) => {
          if (response) {
            this.$emit('success');
            this.$emit('closeModal');
          }
        });
      }
    },
    resetFormConfigValues() {
      for (let key in this.formConfig) {
        this.formConfig[key].model = undefined;
      }
    },
    setRemarks(remarks) {
      this.pumpData['Comment'] = remarks;
    }
  }
};
</script>
